export default "__VITE_ASSET__CJ$DSUll__"